export default __webpack_public_path__ + "static/media/2t.b807fe83.jpg";